// extracted by mini-css-extract-plugin
export var curveFiller = "FAQHeader-module--curveFiller--13uvd";
export var icon = "FAQHeader-module--icon--18yCe";
export var searchBoxInput = "FAQHeader-module--searchBoxInput--2H9Hr";
export var searchBoxTitle = "FAQHeader-module--searchBoxTitle--3P8hO";
export var tileSection = "FAQHeader-module--tileSection--5g3UB";
export var infoCard = "FAQHeader-module--infoCard--2gNci";
export var link = "FAQHeader-module--link--16-SH";
export var CustomCell = "FAQHeader-module--CustomCell--3a3Kg";